import { DEFAULT_COMPANY_REGION } from '@shared/schema/constants.js';
import getPlatformApiBaseUrl from './getPlatformApiBaseUrl.js';

// Match the effective request destination, including the configured API override.
// The shared API and Brazil edge retain US ownership for new companies.
const getDefaultCompanyRegion = ({ apiBaseUrl = getPlatformApiBaseUrl() } = {}) => {
  return new URL(apiBaseUrl).hostname === 'api.eu-north-1.mindcloud.co' ? 'eu-north-1' : DEFAULT_COMPANY_REGION;
};

export default getDefaultCompanyRegion;
